import React, { useState, useEffect } from "react";
import { 
  collection, 
  getDocs,
  addDoc, 
  doc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  runTransaction 
} from "firebase/firestore";


import { db } from "../firebaseConfig";
import { addJobTotal } from "../utils/addJobTotal";
import { useNavigate } from "react-router-dom";
import "./ProposalsPPD.css";
import { sendPPDProposalEmail, describeLastProposalEmail } from "./PPDProposalEmail";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import { serverTimestamp, increment } from "firebase/firestore";

const PPDApprovedProposals = () => {
  const [proposals, setProposals] = useState([]);
  const [properties, setProperties] = useState([]);
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [newProposal, setNewProposal] = useState({
    companyName: "",
    companyAddress: "",
    companyCityStateZip: "",
    siteName: "",
    management: "",
    managerName: "",
    address: "",
    cityStateZip: "",
    scope: "",
    jobDescription: "",
    price: "",
    proposalTotal: "",
    submittedDate: "",
    submittedBy: "",
    images: [],
    terms: "",
    warrantyName: "",     // <-- NEW
    warranty: "",         // (text body stays here)
  });
  const [proposalID, setProposalID] = useState(3000);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [pdfDownloadUrl, setPdfDownloadUrl] = useState(""); // Add state for PDF download URL
  const navigate = useNavigate();
  const [sendingProposalId, setSendingProposalId] = useState(null);
  const goToPPDApprovedProposals = () => {
    navigate("/PPDApprovedProposals");
  };
  
  const goToPPDCompletedProposals = () => {
    navigate("/PPDCompletedProposals");
  };

  const goToPPDSentProposals = () => {
    navigate("/PPDSentProposals");
  };

  const goToProposalsPPD = () => {
    navigate("/ProposalsPPD");
  };

  const [sortOrder, setSortOrder] = useState("asc");

  const [showSubscriptions, setShowSubscriptions] = useState(false);
const [showSingle, setShowSingle] = useState(false);
// Pricing modal and dynamic selection
const [showPriceModal, setShowPriceModal] = useState(false);
const [selectedScope, setSelectedScope] = useState(null);
const [selectedType, setSelectedType] = useState("residential");
const [selectedFrequency, setSelectedFrequency] = useState("Monthly");
const [quantity, setQuantity] = useState(1);
const [includeHeightFee, setIncludeHeightFee] = useState(false);
const [calculatedPrice, setCalculatedPrice] = useState(0);
const [priceBreakdown, setPriceBreakdown] = useState([]);
const [selectedSqFtRange, setSelectedSqFtRange] = useState("Up to 500 sq ft");



  // Helpers
  const formatInitials = (nameOrFirstLast) => {
    if (!nameOrFirstLast) return "";
    // Accept either "First Last" or already-initials and normalize to "F L"
    const parts = String(nameOrFirstLast).trim().split(/\s+/);
    const first = parts[0]?.[0] || "";
    const last  = parts[1]?.[0] || "";
    return [first, last].filter(Boolean).join(" ");
  };
  
  const formatDateMMDDYYYY = (isoOrYmd) => {
    if (!isoOrYmd) return "";
    // Handles "YYYY-MM-DD" from <input type="date"> or full ISO strings
    const d = new Date(isoOrYmd);
    if (Number.isNaN(d.getTime())) return isoOrYmd; // fallback
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  };

  
// ✅ Build a safe PDF/file title for Chrome print "Save as"
const buildPdfTitle = (p) => {
  const site = (p?.siteName || "Site").trim();
  const scope = (p?.scope || "Scope").trim();

  const raw = `${site} - ${scope}`;

  return raw
    .replace(/[/\?%*:|"<>]/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

// ✅ Images used by the displayed proposal, print PDF, saved Storage PDF, and email PDF.
// Handles both the newer imageURLs field and older/edited images arrays.
const getProposalImageUrls = (proposal = {}) => {
  const rawImages = [
    ...(Array.isArray(proposal.imageURLs) ? proposal.imageURLs : []),
    ...(Array.isArray(proposal.images) ? proposal.images : []),
  ];

  const urls = rawImages
    .map((item) => {
      if (typeof item === "string") return item;
      if (item && typeof item === "object") {
        return item.fileURL || item.fileUrl || item.downloadURL || item.url || item.src || "";
      }
      return "";
    })
    .filter(Boolean);

  return Array.from(new Set(urls));
};


  const termsOptions = [
    { name: "Full Payment Before Start (Commonly used)", content: "Full payment of the total contract amount is due in advance before the job is scheduled."},
    { name: "Full Payment After Completion (Commonly used)", content: "Full payment of the total contract amount is due immediately upon completion of the work."},
    {name: "Billing (Payment Due Upon Invoice)", content: "Services will be billed as described in this quote. Payment is due upon invoice, and all recurring service charges must be paid in full by the stated due date."},
    { name: "Half & Half (Commonly used)", content: "A deposit of 50% of the total contract amount is due upon acceptance of this quote. The remaining balance is payable in full upon completion of the work." },
    { name: "1/3 & 1/3", content: "Payment will be made in three equal installments: one-third (1/3) deposit upon acceptance, one-third (1/3) prior to the start of work, and the final one-third (1/3) upon completion." },
    { name: "1/2 & Progress (recommened for large projects)", content: "A 50% deposit is required upon acceptance. The remaining balance will be invoiced in progress payments, with the final payment due upon completion." },
    { name: "1/3 & Progress", content: "A one-third (1/3) deposit is required upon acceptance. The remaining balance will be invoiced in progress payments, with the final payment due upon completion." },
  ];

  const logoOptions = [
    { name: "Priority Pest Defense", url: "https://firebasestorage.googleapis.com/v0/b/priority-backend.firebasestorage.app/o/logo-images%2Fprioritypestlogogreyblue.png?alt=media&token=da273ab0-3054-4675-bb96-3a3a4a242434", alignment: "center" }
  ];

  const PPD_NAME = "Priority Pest Defense LLC";

const serviceTypes = [
  "Action Items",
  "Inspection",
  "Meeting",
  "Proposal",
  "BED - Bed Bug Treatment",
  "HTT - Home Termite Treatment",
  "MPC - Monthly Pest Control",
  "QPC - Quarterly Pest Control",
  "RBS - Rodent Bait Station Service",
  "SEN - Termite Monitoring Station Service",
  "STT - Settlement Termite Treatment",
  "WDI - Wood Destroying Insect Inspection",
  "WLW - Wildlife Removal/Exclusion",
  "WPC - Warranty Pest Control",
  "WYG - Warranty Yard Guard",
  "YG - Yard Guard",
];

  const [selectedLogo, setSelectedLogo] = useState(logoOptions[0]);

  const handleLogoChange = (e) => {
    const selected = logoOptions.find(option => option.name === e.target.value);
    setSelectedLogo(selected);
  };

  const [warrantyOptions] = useState([
    {
      name: "No Warranty",
      content: ({ companyName, siteName }) => `
      ${companyName} understands and agrees that there will be no warranty provided for this scope of work. All services are provided as-is and without any guarantee of continued results, long-term pest prevention, or recurring effectiveness.
      `.trim()
    },
    {
      name: "Property Warranty",
      content: ({ companyName, siteName }) => `
      All work will be completed in a workmanlike manner according to standard practices. Any alteration or deviation from the above specifications involving extra costs will only be performed upon a written change order, and such costs shall become an extra charge over and above the contract price. No guarantees are expressed or implied regarding the effectiveness of work. Performance may be delayed by circumstances beyond the contractor’s control, including but not limited to weather, strikes, supply shortages, or other acts not controlled by ${companyName}.
    
      Deposits are strictly non-refundable once email or written approval is received, or once a signed proposal is executed. Should the Client choose to hire another vendor or cancel the project after providing approval, ${companyName} shall retain the deposit in full and reserves the right to recover costs of all labor, materials purchased, mobilization, preparation, or administrative work performed up to that date. The Client acknowledges that the Contractor cannot be removed from an approved job without the Contractor’s written consent, and any attempted cancellation without consent shall constitute breach of contract.
    
      Due to supply chain and availability issues, certain materials may be substituted with equal or greater quality alternatives at the discretion of ${companyName}, without prior notice and without penalty.
    
      ${companyName} performs all work under the guidelines of the state and/or county where work is being performed and complies with all applicable permit requirements. If permits are required, the cost of those permits shall be the responsibility of ${siteName}.
    
      ${companyName} is not responsible for direct or incidental damage to any items such as (but not limited to) landscaping, irrigation systems, underground utilities, or property features, except in cases of willful misconduct or gross negligence. Any alleged damage must be reported within 48 hours of occurrence, and ${companyName} must be given the opportunity to correct such damage. Proposal pricing does not include alterations required due to hidden or concealed conditions; any such work shall result in additional charges.
    
      ${companyName} provides a One-Year Limited Workmanship Warranty from the date of completion. This warranty does not cover damages or failures caused by: structural defects, settlement, improper drainage, fire, explosion, chemical exposure, extreme weather, vandalism, negligence, acts of God, or other causes beyond the Contractor’s control. This Warranty is applicable only to ${siteName}.
    
      In the event of a dispute, ${companyName} shall be entitled to recover reasonable attorney’s fees and costs associated with enforcing this contract.
      `.trim()
    },
    {
      name: "One-Time Pest Control Terms",
      content: ({ companyName, siteName }) => `
      This agreement covers a one-time pest control service as described in the related proposal or work order. Service is limited to treating the pest issue identified at the time of inspection. No long-term warranty is provided unless explicitly stated in writing.
    
      --- NON-REFUNDABLE DEPOSIT ---
      All deposits paid to ${companyName} are strictly non-refundable for any reason, including client cancellation, rescheduling, or failure to prepare the property. Once approval is given in writing, email, or signature, ${companyName} reserves scheduled technician time, materials, and labor, and deposits will not be returned.
    
      --- PESTICIDE USE & SAFETY ---
      ${companyName} will apply EPA-registered pesticides in accordance with federal, state, and label requirements. Client acknowledges that pesticides may cause health risks if instructions are not followed. Client agrees to:
      - Keep pets, children, and adults away from treated areas until products dry or as directed.
      - Protect sensitive pets (fish, birds, reptiles) by covering or relocating them.
      - Follow all preparation and after-care instructions.
    
      ${companyName} shall not be liable for injuries, allergic reactions, pet illness, or health complications resulting from exposure due to failure to follow instructions or client-controlled conditions.
    
      --- RODENT EXCLUSION & ENTRY POINTS ---
      If rodent exclusion is performed, ${companyName} will seal identified entry points using industry-standard practices. Client acknowledges and agrees:
      - Rodents may re-enter through sealed areas.
      - Rodents may create new entry points at any time.
      - No rodent exclusion method can guarantee complete prevention.
    
      ${companyName} is not responsible for rodent-caused damage or recurrence due to structural defects, sanitation issues, or environmental factors beyond its control.
    
      --- CLIENT RESPONSIBILITIES ---
      Client must provide access to all treatment areas and complete required preparation steps. Failure to prepare properly may reduce treatment effectiveness and void any re-treatment allowances.
    
      --- LIMITATION OF LIABILITY ---
      ${companyName} is not responsible for pre-existing damage, structural deficiencies, hidden conditions, or pest-related damage. ${companyName} shall not be liable for any incidental or consequential damages.
    
      --- CANCELLATION POLICY ---
      Cancellations made less than 24 hours before service, or inability to access the property, will incur a trip fee.
    
      This agreement is governed by the laws of the state where service is performed.
      `.trim()
    },
    
    {
      name: "Residential Subscription Terms",
      content: ({ companyName, siteName }) => `
      This agreement establishes a recurring pest control subscription for ${siteName}. The minimum service term is 12 months and automatically renews unless cancelled in writing.
    
      --- NON-REFUNDABLE DEPOSITS & FEES ---
      All initial deposits, setup fees, and specialized treatment charges are non-refundable. Cancelling before fulfilling the minimum term may result in early termination fees.
    
      --- SERVICE SCOPE ---
      The subscription covers only the pests listed in the plan. Specialty pests such as termites, bed bugs, wildlife, birds, or structural pests require separate agreements.
    
      --- PESTICIDE SAFETY & LIABILITY ---
      ${companyName} applies pesticides per EPA regulations. Client must comply with all safety guidelines. ${companyName} is not liable for reactions, pet illness, or damages caused by failure to follow instructions.
    
      --- RODENT EXCLUSION ---
      If included, exclusion does not guarantee full prevention. Rodents may chew through sealed areas or create new ones. This is beyond the control of ${companyName}.
    
      --- RE-SERVICE GUARANTEE ---
      ${companyName} will re-treat for covered pests between scheduled services at no charge, provided client:
      - Maintains sanitation
      - Addresses structural or moisture issues
      - Follows technician recommendations
    
      Failure to correct contributing conditions voids the guarantee.
    
      --- BILLING & AUTOMATIC PAYMENTS ---
      Subscription fees are billed monthly or annually. Declined payments must be corrected within 7 days. Service may be suspended for non-payment.
    
      --- LIABILITY ---
      ${companyName} is not responsible for pest-caused damage, structural defects, moisture issues, or failures caused by client-controlled conditions.
    
      --- CANCELLATION ---
      Written notice is required. Early termination fees may apply.
    
      `.trim()
    },
    {
      name: "Commercial Pest Control Terms",
      content: ({ companyName, siteName }) => `
      This agreement applies to commercial pest control services for ${siteName}. Service scope, frequency, and covered pests are defined in the proposal.
    
      --- NON-REFUNDABLE DEPOSITS ---
      Deposits, retainers, and setup fees are non-refundable for any reason, including scheduling changes, cancellations, regulatory shutdowns, or loss of access.
    
      --- PESTICIDE USE & REGULATORY COMPLIANCE ---
      ${companyName} applies pesticides in compliance with EPA, OSHA, and local health codes. Client must ensure staff and customers follow posted safety instructions. ${companyName} is not responsible for third-party exposure due to client non-compliance.
    
      --- RODENT & EXCLUSION LIMITATIONS ---
      Exclusion work is not guaranteed to prevent future rodent entry. Rodents may chew through materials or create new openings.
    
      --- SANITATION & STRUCTURAL REQUIREMENTS ---
      Warranty and re-service depend on:
      - Adequate sanitation
      - Proper waste handling
      - Elimination of harborage areas
      - Correction of structural defects
    
      Failure to comply voids service guarantees.
    
      --- LIABILITY ---
      ${companyName} is not responsible for:
      - Loss of revenue
      - Damage to inventory or food
      - Health department violations arising from client conditions
      - Pre-existing or hidden problems
    
      --- PAYMENT TERMS ---
      Standard net terms apply. Late payments may incur interest and service suspension.
    
      `.trim()
    },
    {
      name: "Residential Homeowner Terms",
      content: ({ companyName, siteName }) => `
      These terms apply to all pest control services provided at ${siteName}.
    
      --- DEPOSITS ---
      All deposits are non-refundable, regardless of cancellation reason.
    
      --- PESTICIDE SAFETY ---
      Client agrees to follow all preparation and after-care instructions. ${companyName} is not liable for property or health damages resulting from improper compliance, including pets, children, elderly individuals, or sensitive persons.
    
      --- RODENT ENTRY POINTS ---
      Sealing entry points reduces activity but does not eliminate rodent risk. Rodents may re-enter or create new openings.
    
      --- CLIENT RESPONSIBILITIES ---
      Client must maintain sanitation, reduce clutter, repair structural issues, and provide access.
    
      --- SERVICE LIMITATIONS ---
      ${companyName} cannot guarantee results when pest activity is caused by:
      - Neighboring units
      - Shared walls
      - Moisture problems
      - Hoarding or clutter
      - Open food or trash sources
      - Structural defects
    
      --- LIABILITY ---
      ${companyName} is not responsible for:
      - Pest-caused damage
      - Structural failures
      - Damages caused by conditions beyond its control
    
      --- CANCELLATION ---
      Less than 24-hour notice or inaccessible property may incur fees.
    
      `.trim()
    },
    {
      name: "Commercial Subscription Terms",
      content: ({ companyName, siteName }) => `
      This agreement establishes a recurring commercial pest control subscription for ${siteName}, performed on a monthly, bi-monthly, or quarterly schedule as outlined in the service plan. The minimum service term is twelve (12) months and automatically renews annually unless cancelled in writing.
    
      --- NON-REFUNDABLE DEPOSITS & INITIAL FEES ---
      All deposits, startup costs, inspection fees, and specialized treatment fees paid to ${companyName} are strictly non-refundable for any reason, including but not limited to cancellation, change of management, regulatory shutdown, construction, or customer delays. Once service approval is given, ${companyName} reserves technician labor, scheduling, materials, and administrative resources.
    
      --- SERVICE SCOPE ---
      The subscription covers only the pests and service areas identified in the commercial service plan. Specialty pests (including termites, bed bugs, wildlife, birds, stored-product pests, and structural pests) require separate agreements.
    
      ${companyName} shall not be responsible for pest activity arising from:
      - Structural defects or construction gaps
      - Food storage or sanitation violations
      - Dumpster overflow or improper trash handling
      - Employee habits or unsafe storage practices
      - Moisture, plumbing leaks, or HVAC issues
      - Neighboring business conditions
    
      --- PESTICIDE USE, SAFETY & COMPLIANCE ---
      ${companyName} applies EPA-registered pesticides in accordance with federal, state, local, OSHA, and food-safety regulations. ${siteName} agrees to:
      - Notify employees and occupants of treatment areas
      - Follow posted re-entry restrictions
      - Provide safe access to all service zones
      - Protect sensitive inventory, food products, electronics, or equipment
    
      ${companyName} is not liable for:
      - Food contamination
      - Employee or patron exposure due to facility non-compliance
      - Product loss, inventory loss, or regulatory violations resulting from customer-controlled conditions
    
      --- RODENT EXCLUSION (LIMITATIONS) ---
      If rodent exclusion is included or added:
      - ${companyName} will seal accessible entry points using commercial-grade materials.
      - Rodents may chew through sealed areas or create new openings at any time.
      - No exclusion method or subscription program can guarantee prevention.
    
      ${companyName} is not responsible for rodent-caused equipment damage, fire hazards, or inventory damage.
    
      --- SANITATION, STORAGE, AND STRUCTURAL REQUIREMENTS ---
      To maintain service effectiveness, ${siteName} must:
      - Follow all sanitation and storage recommendations
      - Maintain clean food preparation and waste areas
      - Keep dumpsters closed and serviced regularly
      - Repair leaks, gaps, soffits, walls, door sweeps, seals, or structural deficiencies
      - Eliminate harborage areas
    
      Failure to correct these conditions voids all guarantees.
    
      --- RE-SERVICE GUARANTEE ---
      ${companyName} will provide complimentary re-treatment for covered pests between regular visits, provided that:
      - Sanitation remains acceptable
      - No structural deficiencies interfere with service
      - All recommendations by ${companyName} are followed
    
      Excessive or persistent activity caused by client-controlled conditions may incur additional charges.
    
      --- ACCESS REQUIREMENTS ---
      Missed, blocked, or delayed service visits due to restricted access, tenant refusal, construction closures, or management issues may result in trip charges at ${companyName}'s discretion.
    
      --- BILLING, PAYMENTS & AUTO-RENEWAL ---
      Subscription fees are billed monthly or quarterly based on contract terms. Payment terms may include automatic billing or standard net terms as stated in invoices. Service may be suspended for non-payment.
    
      Customer agrees that:
      - Unpaid invoices may incur late fees
      - Service may be paused or cancelled due to non-payment
      - Renewal pricing may be adjusted annually with notice
    
      --- LIABILITY LIMITATIONS ---
      ${companyName} shall not be liable for:
      - Loss of revenue
      - Inventory loss or spoilage
      - Food contamination
      - Structural damage caused by pests
      - Penalties, fines, or closures issued by regulatory authorities
      - Hidden or concealed conditions affecting treatment results
    
      ${siteName} agrees to indemnify and hold harmless ${companyName} against claims arising from:
      - Non-compliance with sanitation or safety regulations
      - Failure to follow pest-control recommendations
      - Unsafe property conditions
      - Employee or customer injuries not caused by ${companyName}'s negligence
    
      --- CANCELLATION ---
      Cancellation must be made in writing. Early termination before the 12-month minimum may result in payment of the remaining contract balance or an early-cancellation fee equal to three (3) months of service, whichever is greater.
    
      --- GOVERNING LAW ---
      This agreement is governed by the laws of the state where services are performed.
      `.trim()
    }
    
    
  ]);

  const handleWarrantyChange = (e) => {
    const name = e.target.value;
    const found = warrantyOptions.find(opt => opt.name === name);
    if (!found) return;
  
    const text = found.content({
      companyName: newProposal.companyName || selectedProposal?.companyName || "",
      siteName: newProposal.siteName || selectedProposal?.siteName || ""
    });
  
    setNewProposal(prev => ({
      ...prev,
      warrantyName: name,
      warranty: text
    }));
  };

  useEffect(() => {
    const fetchProposals = async () => {
      const proposalsRef = collection(db, "proposals");
      const querySnapshot = await getDocs(proposalsRef);
      const proposalsData = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((proposal) => proposal.status === "Approved");

      setProposals(proposalsData);
    };

    const fetchProperties = async () => {
      const propertiesRef = collection(db, "properties");
      const querySnapshot = await getDocs(propertiesRef);
      const propertiesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProperties(propertiesData);
    };

    const fetchUsers = async () => {
      const usersRef = collection(db, "users");
      const querySnapshot = await getDocs(usersRef);
      const usersData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(usersData);
    };

    const fetchCompanies = async () => {
      const companiesRef = collection(db, "companies");
      const querySnapshot = await getDocs(companiesRef);
      const companiesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCompanies(companiesData);
    };

    fetchProposals();
    fetchProperties();
    fetchUsers();
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (selectedProposal) {
      setNewProposal({
        companyName: selectedProposal.companyName || "",
        companyAddress: selectedProposal.companyAddress || "",
        companyCityStateZip: selectedProposal.companyCityStateZip || "",
        siteName: selectedProposal.siteName || "",
        management: selectedProposal.management || "",
        managerName: selectedProposal.managerName || "",
        address: selectedProposal.address || "",
        cityStateZip: selectedProposal.cityStateZip || "",
        serviceType: selectedProposal.serviceType || "",
        scope: selectedProposal.scope || "",
        dropdownValues: selectedProposal.dropdownValues || {},
        jobDescription: selectedProposal.jobDescription || "",
        price: selectedProposal.price || "",
        proposalTotal: selectedProposal.proposalTotal || selectedProposal.contractAmount || selectedProposal.estimatedTotal || "",
        submittedDate: selectedProposal.submittedDate || "",
        submittedBy: selectedProposal.submittedBy || "",
        images: selectedProposal.images || [],
        terms: selectedProposal.terms || "",
        warrantyName: selectedProposal.warrantyName || "",
        warranty: selectedProposal.warranty || "",
      });
    }
  }, [selectedProposal]);

  const sortedProperties = properties.sort((a, b) => a.propertyName.localeCompare(b.propertyName));

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProposal((prev) => ({ ...prev, [name]: value }));
  };

  const handleCompanyNameChange = (e) => {
    const selectedCompany = companies.find(company => company.companyName === e.target.value);
    const matchedLogo = logoOptions.find(logo => logo.name === selectedCompany.companyName);
    setNewProposal((prev) => ({
      ...prev,
      companyName: selectedCompany.companyName,
      companyAddress: selectedCompany.companyAddress || "",
      companyCityStateZip: `${selectedCompany.companyCity}, ${selectedCompany.companyState} ${selectedCompany.companyZip}` || ""
    }));
    if (matchedLogo) {
      setSelectedLogo(matchedLogo);
    }
  };

  const handleSiteNameChange = (e) => {
    const selectedProperty = properties.find(property => property.propertyName === e.target.value);
    setNewProposal((prev) => ({
      ...prev,
      siteName: selectedProperty.propertyName,
      management: selectedProperty.management || "",
      managerName: selectedProperty.managerName || "",
      address: selectedProperty.address || selectedProperty.managementAddress || "",
      cityStateZip: `${selectedProperty.city || selectedProperty.managementCity}, ${selectedProperty.state || selectedProperty.managementState} ${selectedProperty.zip || selectedProperty.managementZip}` || ""
    }));
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setNewProposal(prevState => ({
      ...prevState,
      images: [...prevState.images, ...selectedFiles], // Append new files without removing URLs
    }));
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { images, ...proposalData } = newProposal;
      const proposalDocRef = await addDoc(collection(db, "proposals"), {
        ...proposalData,
        status: "Not Sent",
        hasBeenSent: false
      });
      let imageURLs = [];
      if (images.length > 0) {
        const storage = getStorage();
        const uploadPromises = images.map(async (file) => {
          const storageRef = ref(storage, `proposals/${proposalDocRef.id}/${file.name}`);
          await uploadBytes(storageRef, file);
          return await getDownloadURL(storageRef);
        });
        imageURLs = await Promise.all(uploadPromises);
        await updateDoc(proposalDocRef, { imageURLs });
      }

      setProposals([...proposals, { id: proposalDocRef.id, ...proposalData, imageURLs }]);
      setProposalID(proposalID + 1);
      setNewProposal({
        companyName: "",
        companyAddress: "",
        companyCityStateZip: "",
        siteName: "",
        management: "",
        managerName: "",
        address: "",
        cityStateZip: "",
        serviceType: "",
        scope: "",
        jobDescription: "",
        price: "",
    proposalTotal: "",
        submittedDate: "",
        submittedBy: "",
        images: [],
        terms: "",
        warranty: "",
      });
      setIsEditing(false);
    } catch (error) {
      console.error("Error adding proposal:", error);
    }
  };

  const handleEditProposal = async () => {
    try {
      const proposalRef = doc(db, "proposals", selectedProposal.id);
  
      // Extract files from newProposal.images
      const files = newProposal.images.filter(img => img instanceof File);
      let imageURLs = selectedProposal.imageURLs || []; // Keep existing URLs
  
      if (files.length > 0) {
        const storage = getStorage();
        const uploadPromises = files.map(async (file) => {
          const storageRef = ref(storage, `proposals/${selectedProposal.id}/${file.name}`);
          await uploadBytes(storageRef, file);
          return await getDownloadURL(storageRef);
        });
  
        const uploadedImageURLs = await Promise.all(uploadPromises);
        imageURLs = [...imageURLs, ...uploadedImageURLs]; // Merge new and old URLs
      }
  
      // Update Firestore (store URLs, not files)
      await updateDoc(proposalRef, { 
        ...newProposal, 
        images: imageURLs 
      });
  
      // Update UI
      setProposals(proposals.map(proposal => 
        proposal.id === selectedProposal.id ? { ...proposal, imageURLs, images: imageURLs } : proposal
      ));
  
      setSelectedProposal({ ...selectedProposal, imageURLs, images: imageURLs });
      setIsEditing(false);
    } catch (error) {
      console.error("Error updating proposal:", error);
    }
  };
  

  const handleDeleteProposal = async () => {
    try {
      const proposalRef = doc(db, "proposals", selectedProposal.id);
      await deleteDoc(proposalRef);
      setProposals(proposals.filter(proposal => proposal.id !== selectedProposal.id));
      setSelectedProposal(null);
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error("Error deleting proposal:", error);
    }
  };

  const handleCancel = () => {
    setNewProposal({
      companyName: "",
      companyAddress: "",
      companyCityStateZip: "",
      siteName: "",
      management: "",
      managerName: "",
      address: "",
      cityStateZip: "",
      serviceType: "",
      scope: "",
      jobDescription: "",
      price: "",
    proposalTotal: "",
      submittedDate: "",
      submittedBy: "",
      images: [],
      terms: "",
      warranty: "",
    });
    setIsEditing(false);
  };

  const parseJobDescription = (description) => {
    if (!description) return null;
    return description.split('\n').map((line, index) => {
      if (line.startsWith('((b))')) {
        return <p key={index} className="bold">{line.replace('((b))', '')}</p>;
      } else if (line.startsWith('((i))')) {
        return <p key={index} className="italic">{line.replace('((i))', '')}</p>;
      } else if (line.startsWith('((-))')) {
        return <li key={index} className="bullet">{line.replace('((-))', '')}</li>;
      } else {
        return <p key={index}>{line}</p>;
      }
    });
  };

  const handleEditClick = () => {
    if (selectedProposal) {
      setNewProposal({
        companyName: selectedProposal.companyName || "",
        companyAddress: selectedProposal.companyAddress || "",
        companyCityStateZip: selectedProposal.companyCityStateZip || "",
        siteName: selectedProposal.siteName || "",
        management: selectedProposal.management || "",
        managerName: selectedProposal.managerName || "",
        address: selectedProposal.address || "",
        cityStateZip: selectedProposal.cityStateZip || "",
        serviceType: selectedProposal.serviceType || "",
        scope: selectedProposal.scope || "",
        jobDescription: selectedProposal.jobDescription || "",
        price: selectedProposal.price || "",
        proposalTotal: selectedProposal.proposalTotal || selectedProposal.contractAmount || selectedProposal.estimatedTotal || "",
        submittedDate: selectedProposal.submittedDate || "",
        submittedBy: selectedProposal.submittedBy || "",
        images: selectedProposal.images || [],
        terms: selectedProposal.terms || "",
        warranty: selectedProposal.warranty || "",
      });
      setIsEditing(true);
    }
  };
  // Open/Close modal
const openPricingModal = (scope) => {
  setSelectedScope(scope);
  setSelectedType("residential");
  setSelectedFrequency(scope.frequencyOptions?.[0] || "One-Time");
  setQuantity(1);
  setIncludeHeightFee(false);
  setCalculatedPrice(scope.basePrice || 0);
  setShowPriceModal(true);
};

const closePriceModal = () => setShowPriceModal(false);

// Auto calculate total based on selection
useEffect(() => {
  if (!selectedScope) return;

  const base =
    selectedScope.pricingOptions?.[selectedType]?.install ||
    selectedScope.basePrice ||
    0;

  const quantityFee =
    selectedScope.modifiers?.find((m) => m.valuePerUnit)?.valuePerUnit *
      (quantity - 1) || 0;

  const heightFee = includeHeightFee
    ? selectedScope.modifiers?.find((m) => m.label.includes("Height"))?.value || 0
    : 0;

    let total = base + quantityFee + heightFee;

    // 🪰 Mosquito tier override
    if (selectedScope.title.includes("Mosquito")) {
      const tier = mosquitoTiers.find((t) => t.range === selectedSqFtRange);
      if (tier) total = tier.price;
    }
  
    setCalculatedPrice(total);
  }, [selectedType, quantity, includeHeightFee, selectedScope, selectedSqFtRange]);

  

  const buildPrintDocument = () => {
    const printable = document.getElementById("printableArea");
    if (!printable) return null;

    const title = buildPdfTitle(selectedProposal);
    const content = printable.outerHTML;
    const printCss = `
    <style>
      /* Paper */
      @page {
        size: Letter;
        margin: 0.5in;
      }
  
      html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        color: #111;
  
        /* ✅ CHANGE: new PDF font */
        font: 11.5pt/1.45 Arial, Helvetica, sans-serif;
      }
  
      /* Hide app controls in print */
      @media print { .no-print { display: none !important; } }
  
      /* ✅ CHANGE: remove borders + add shadow look */
      .page-border {
        border: none !important;
        border-radius: 10px !important;
        padding: 18px !important;
        background: #fff !important;
        box-shadow: 0 10px 24px rgba(0,0,0,0.14) !important;
      }
  
      /* ✅ CHANGE: top row layout in print */
      @media print {
        .pdf-top-row {
          display: flex !important;
          gap: 14px !important;
          align-items: flex-start !important;
          margin: 0 0 14px 0 !important;
        }
        .pdf-header {
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-end !important; /* ✅ logo + company info to the right */
          gap: 8px !important;
        }
      }
  
      /* ✅ CHANGE: logo top-right (print only) */
      .companylogo-container {
        text-align: right !important;
        margin: 0 !important;
        width: 100% !important;
      }
      .companylogo-container img.resizable-logo {
        width: 140px !important;
        max-width: 140px !important;
        height: auto !important;
        display: inline-block !important;
      }
  
      /* ✅ CHANGE: remove borders on all section cards + add shadow */
      .companyinfo-container,
      .property-container,
      .scope-container,
      .description-container,
      .total-container,
      .image-container,
      .terms-container,
      .warranty-container,
      .acceptance-container,
      .noteacceptance-container {
        border: none !important;
        outline: none !important;
        border-radius: 10px !important;
        padding: 12px !important;
        background: #fff !important;
        box-shadow: 0 8px 18px rgba(0,0,0,0.12) !important;
        margin-bottom: 12px !important;
  
        break-inside: auto !important;
        page-break-inside: auto !important;
        overflow: visible !important;
      }
  
      /* Text tweaks */
      .companyinfo-container p,
      .property-container p,
      .scope-container p,
      .description-container p,
      .total-container p,
      .terms-container p,
      .warranty-container p,
      .noteacceptance-container p,
      .acceptance-container p {
        margin: 4px 0 !important;
        font-size: 10.75pt !important;
        line-height: 1.35 !important;
        word-break: break-word !important;
        overflow-wrap: anywhere !important;
      }
  
      .total-text {
        white-space: pre-line !important;
        line-height: 1.35 !important;
        font-size: 11.25pt !important;
      }
  
      .job-bullet { display: block !important; margin-left: 10px !important; }
      .job-bold   { font-weight: 700 !important; }
      .job-italic { font-style: italic !important; }
  
      /* Images: grid that can flow naturally */
      .image-grid {
        display: grid !important;
        grid-template-columns: repeat(3, 1fr) !important;
        gap: 8px !important;
        justify-content: center !important;
      }
      .image-wrapper {
        border: none !important;
        border-radius: 8px !important;
        background: #fafafa !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        overflow: hidden !important;
        width: 100% !important;
        aspect-ratio: 1 / 1 !important;
        break-inside: avoid !important;
        page-break-inside: avoid !important;
        box-shadow: 0 6px 14px rgba(0,0,0,0.10) !important;
      }
      .proposal-image { width: 100% !important; height: 100% !important; object-fit: contain !important; }
  
      .signature-row p { font-size: 10.75pt !important; margin: 2px 0 !important; }
  
      .page-break { break-before: page !important; page-break-before: always !important; }
    </style>
  `;

    return {
      title,
      html: `
        <!doctype html>
        <html>
          <head>
            <meta charset="utf-8" />
            <title>${title}</title>
            ${printCss}
          </head>
          <body>
            ${content}
          </body>
        </html>
      `,
    };
  };

  const openPrintPreview = () => {
    const printDocument = buildPrintDocument();
    if (!printDocument) return;

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.setAttribute("aria-hidden", "true");
    document.body.appendChild(iframe);

    const frameWindow = iframe.contentWindow || iframe;
    const frameDocument = frameWindow.document || iframe.contentDocument;

    frameDocument.open();
    frameDocument.write(printDocument.html);
    frameDocument.close();

    const doPrint = () => {
      try { frameWindow.focus(); } catch {}
      try { frameWindow.print(); } catch {}
      setTimeout(() => {
        try { document.body.removeChild(iframe); } catch {}
      }, 1000);
    };

    if (frameDocument.readyState === "complete") {
      setTimeout(doPrint, 150);
    } else {
      iframe.onload = () => setTimeout(doPrint, 150);
    }
  };

  const handlePrint = async () => {
    if (!selectedProposal) return;

    // 1) Open the browser print dialog using the exact same rendered proposal HTML.
    openPrintPreview();

    // 2) Save that same print document to Storage for emailing.
    try {
      const printDocument = buildPrintDocument();
      if (!printDocument) return;

      const now = new Date();
      const timestamp = now.toISOString();
      const proposalPDFname = `${printDocument.title}.pdf`;
      const storagePath = `proposals/${selectedProposal.id}/pdfs/${proposalPDFname}`;

      const holder = document.createElement("div");
      holder.style.position = "fixed";
      holder.style.left = "-10000px";
      holder.style.top = "0";
      holder.style.width = "7.5in";
      holder.innerHTML = printDocument.html;
      document.body.appendChild(holder);

      const target = holder.querySelector(".printable-content") || holder.querySelector("#printableArea");
      if (!target) {
        document.body.removeChild(holder);
        throw new Error("Printable proposal content was not found.");
      }

      // html2pdf does not honor @media print the same way the browser print dialog does.
      // Remove the app-only controls before creating the saved/email PDF so the PDF ends at Warranty.
      target.querySelectorAll(".no-print").forEach((el) => el.remove());

      const pdfBlob = await html2pdf()
        .set({
          margin: [0.5, 0.5, 0.5, 0.5],
          filename: proposalPDFname,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: "#ffffff",
          },
          jsPDF: {
            unit: "in",
            format: "letter",
            orientation: "portrait",
          },
          pagebreak: {
            mode: ["css", "legacy"],
            avoid: [
              ".image-wrapper",
              ".image-container",
              ".terms-container",
              ".warranty-container",
              ".acceptance-container",
              ".total-container",
              ".scope-container",
            ],
          },
        })
        .from(target)
        .outputPdf("blob");

      document.body.removeChild(holder);

      const storage = getStorage();
      const pdfRef = ref(storage, storagePath);

      await uploadBytes(pdfRef, pdfBlob, {
        contentType: "application/pdf",
      });

      const downloadURL = await getDownloadURL(pdfRef);
      setPdfDownloadUrl(downloadURL);

      const proposalRef = doc(db, "proposals", selectedProposal.id);

      const pdfFields = {
        latestProposalPdfUrl: downloadURL,
        latestProposalPdfName: proposalPDFname,
        latestProposalPdfStoragePath: storagePath,
        latestProposalPdfGeneratedAt: timestamp,
      };

      await updateDoc(proposalRef, pdfFields);

      // Keep the open Details popup and list row current so Click to Send uses this PDF immediately.
      setSelectedProposal((prev) =>
        prev?.id === selectedProposal.id ? { ...prev, ...pdfFields } : prev
      );
      setProposals((prev) =>
        prev.map((p) =>
          p.id === selectedProposal.id ? { ...p, ...pdfFields } : p
        )
      );

      await addDoc(collection(db, `proposals/${selectedProposal.id}/pdfs`), {
        proposalPDF: downloadURL,
        proposalPDFname,
        storagePath,
        timestamp,
        dateTimeString: now.toLocaleString(),
      });

      await matchAndAddPdfToJob(
        selectedProposal.siteName,
        selectedProposal.scope,
        downloadURL,
        proposalPDFname,
        timestamp,
        now.toLocaleString()
      );
    } catch (err) {
      console.error("Error generating print-version PDF:", err);
      alert("Could not save the print-version PDF for emailing.");
    }
  };
  
  
  const matchAndAddPdfToJob = async (siteName, scope, pdfURL, pdfName, timestamp, dateTimeString) => {
    try {
      // Fetch jobs collection
      const jobsRef = collection(db, "jobs");
      const querySnapshot = await getDocs(jobsRef);
  
      // Find a job that matches the siteName and scope
      const matchingJobDoc = querySnapshot.docs.find(
        (doc) => doc.data().siteName === siteName && doc.data().scope === scope
      );
  
      if (matchingJobDoc) {
        const jobId = matchingJobDoc.id;
        const jobRef = doc(db, "jobs", jobId);
  
        // Get existing PDFs array or initialize a new one
        const existingJobData = matchingJobDoc.data();
        const existingPdfs = existingJobData.proposalPdfs || [];
  
        // Add the new PDF to the array
        const updatedPdfs = [...existingPdfs, { pdfURL, pdfName, timestamp, dateTimeString }];
  
        // Update Firestore with the new PDF
        await updateDoc(jobRef, { proposalPdfs: updatedPdfs });
  
        console.log(`PDF successfully added to job with ID: ${jobId}`);
      } else {
        console.warn(`No matching job found for Site: ${siteName}, Scope: ${scope}`);
      }
    } catch (error) {
      console.error("Error updating job with PDF:", error);
    }
  };
  
const getImageData = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

const generatePDF = async (proposal, fontSize = 12, termsFontSize = 12, termsFontStyle = 'normal') => {
    const doc = new jsPDF();
    doc.setFontSize(fontSize);
    
    // Add border
    doc.rect(10, 10, 190, 277);

    // Logo container
    doc.setDrawColor(0);
    doc.setFillColor(255, 255, 255);
    doc.rect(15, 20, 180, 30, 'FD');
    doc.text("Logo:", 20, 30);
    if (proposal.logo) {
        const logoImage = await getImageData(proposal.logo);
        doc.addImage(logoImage, 'JPEG', 20, 35, 50, 15);
    }

    let yOffset = 60;

    // Company container
    doc.setFillColor(255, 255, 255);
    const companyHeight = 10 + (proposal.companyName ? 10 : 0) + (proposal.companyAddress ? 10 : 0) + (proposal.companyCityStateZip ? 10 : 0);
    doc.rect(15, yOffset, 180, companyHeight, 'FD');
    doc.text("Company:", 20, yOffset + 10);
    if (proposal.companyName) doc.text(proposal.companyName, 105, yOffset + 20, { maxWidth: 170, align: 'center' });
    if (proposal.companyAddress) doc.text(proposal.companyAddress, 105, yOffset + 30, { maxWidth: 170, align: 'center' });
    if (proposal.companyCityStateZip) doc.text(proposal.companyCityStateZip, 105, yOffset + 40, { maxWidth: 170, align: 'center' });
    yOffset += companyHeight + 10;

    // Site container
    const siteHeight = 10 + (proposal.siteName ? 10 : 0) + (proposal.management ? 10 : 0) + (proposal.managerName ? 10 : 0) + (proposal.address ? 10 : 0);
    doc.rect(15, yOffset, 180, siteHeight, 'FD');
    doc.text("Site:", 20, yOffset + 10);
    if (proposal.siteName) doc.text(`Site: ${proposal.siteName}`, 20, yOffset + 20, { maxWidth: 170 });
    if (proposal.management) doc.text(`Management: ${proposal.management}`, 20, yOffset + 30, { maxWidth: 170 });
    if (proposal.managerName) doc.text(`Manager: ${proposal.managerName}`, 20, yOffset + 40, { maxWidth: 170 });
    if (proposal.address) doc.text(`Address: ${proposal.address}`, 20, yOffset + 50, { maxWidth: 170 });
    yOffset += siteHeight + 10;

    // Scope container
    const scopeHeight = 20;
    doc.rect(15, yOffset, 180, scopeHeight, 'FD');
    doc.text("Scope:", 20, yOffset + 10);
    doc.text(proposal.scope || '', 20, yOffset + 20, { maxWidth: 170 });
    yOffset += scopeHeight + 10;

    // Job Description container
    const jobDescriptionLines = (proposal.jobDescription || '').split('\n');
    const jobDescriptionText = jobDescriptionLines.map(line => `• ${line}`).join('\n');
    const jobDescriptionHeight = jobDescriptionLines.length * 10 + 10; // Adjust height based on line count

    doc.rect(15, yOffset, 180, jobDescriptionHeight, 'FD'); // Single container
    doc.text("Job Description:", 20, yOffset + 10);
    doc.text(jobDescriptionText, 20, yOffset + 20, { maxWidth: 170, align: 'left' });

    yOffset += jobDescriptionHeight + 10; // Adjust for next section

    // Total Price container
    const totalPriceHeight = 20;
    doc.rect(15, yOffset, 180, totalPriceHeight, 'FD');
    doc.text("Total Price:", 20, yOffset + 10);
    doc.text(`$${proposal.price || ''}`, 20, yOffset + 20, { maxWidth: 170 });
    yOffset += totalPriceHeight + 10;

    // Options container
    if (proposal.options && proposal.options.length > 0) {
        doc.addPage();
        yOffset = 10;
        const optionsHeight = 20 + proposal.options.length * 10;
        doc.setFillColor(255, 255, 255);
        doc.rect(15, yOffset, 180, optionsHeight, 'FD');
        doc.text("Options:", 20, yOffset + 10);
        proposal.options.forEach((option, index) => {
            doc.text(`Option ${String.fromCharCode(65 + index)} Total: ${option}`, 20, yOffset + 20 + index * 10, { maxWidth: 170 });
        });
        yOffset += optionsHeight + 10;
    }

    // Additional Note container
    doc.addPage();
    yOffset = 10;
    const additionalNoteHeight = 30;
    doc.setFillColor(255, 255, 255);
    doc.rect(15, yOffset, 180, additionalNoteHeight, 'FD');
    doc.text("Additional Note:", 20, yOffset + 10);
    doc.text(proposal.additionalNote || '', 20, yOffset + 20, { maxWidth: 170 });
    yOffset += additionalNoteHeight + 10;

    // Image Upload container
    if (proposal.images && proposal.images.length > 0) {
        doc.addPage();
        yOffset = 10;
        const imagesHeight = 20 + Math.ceil(proposal.images.length / 3) * 110; // Adjust height based on image count
        doc.setFillColor(255, 255, 255);
        doc.rect(15, yOffset, 180, imagesHeight, 'FD');
        doc.text("Images:", 20, yOffset + 10);
        for (const [index, imageUrl] of proposal.images.entries()) {
            const imageData = await getImageData(imageUrl);
            const x = 20 + (index % 3) * 60; // Adjust x position for 3 images per row
            const y = yOffset + 20 + Math.floor(index / 3) * 100; // Adjust y position for each row
            doc.addImage(imageData, 'JPEG', x, y, 50, 50); // Adjust
        }
        yOffset += imagesHeight + 10;
    }

    // Add page break for terms
    doc.addPage();
    yOffset = 10;
    doc.rect(10, 10, 190, 277);
    
    // Terms & Conditions
    doc.setFontSize(termsFontSize);
    doc.setFont('helvetica', termsFontStyle);
    doc.text("Terms & Conditions:", 15, yOffset + 10);

    // Handle line breaks in terms
    const termsLines = (proposal.terms || '').split('\n');
    yOffset += 20;
    termsLines.forEach(line => {
        doc.text(line, 15, yOffset, { maxWidth: 180 });
        yOffset += 10;
    });
    
    // Save PDF
    const filename = `${proposal.siteName} ${proposal.scope}`.replace(/[/\\?%*:|"<>]/g, '') + '.pdf';
doc.save(filename);
};

const generateAndUploadPDF = async () => {
    const doc = new jsPDF();
    doc.text("This is a dynamically created PDF stored in Firebase!", 10, 10);
    const pdfBlob = doc.output("blob");

    const storage = getStorage();
    const pdfRef = ref(storage, `generated_pdfs/my_generated_pdf.pdf`);

    try {
      const snapshot = await uploadBytes(pdfRef, pdfBlob);
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log("PDF uploaded successfully:", downloadURL);

      document.getElementById("pdfLink").href = downloadURL;
      document.getElementById("pdfLink").innerText = "Download Generated PDF";
      document.getElementById("pdfViewer").src = downloadURL;
    } catch (error) {
      console.error("Error uploading PDF:", error);
    }
  };

const handleAddProposalClick = () => {
  const ppd = companies.find(c => c.companyName === PPD_NAME);
  setNewProposal({
    companyName: PPD_NAME,
    companyAddress: ppd?.companyAddress || "",
    companyCityStateZip: ppd ? `${ppd.companyCity}, ${ppd.companyState} ${ppd.companyZip}` : "",
    siteName: "",
    management: "",
    managerName: "",
    address: "",
    cityStateZip: "",
    serviceType: "",
    scope: "",
    jobDescription: "",
    price: "",
    proposalTotal: "",
    submittedDate: "",
    submittedBy: "",
    images: [],
    terms: "",
    warrantyName: "",
    warranty: "",
  });
  // ensure the PPD logo is selected
  setSelectedLogo(logoOptions[0]);
  setIsEditing(true);
};


const handleCloseDetails = () => {
  setSelectedProposal(null);
};

const handleDeleteProposalDirect = async (proposalId) => {
  try {
    const proposalRef = doc(db, "proposals", proposalId);
    await deleteDoc(proposalRef);
    setProposals(prev => prev.filter(p => p.id !== proposalId));
  } catch (error) {
    console.error("Error deleting proposal:", error);
    alert("Failed to delete proposal.");
  }
};


const handleAddToSentFolder = async (proposal) => {
  if (!proposal?.id) return;
  const confirmed = window.confirm("Move this proposal to the Sent folder without emailing it?");
  if (!confirmed) return;
  try {
    await updateDoc(doc(db, "proposals", proposal.id), {
      status: "Sent",
      hasBeenSent: true,
      manuallyMarkedSent: true,
      manuallyMarkedSentAt: new Date().toISOString(),
    });
    setProposals((prev) => prev.filter((p) => p.id !== proposal.id));
    alert("Proposal added to the Sent folder.");
  } catch (error) {
    console.error("Error adding proposal to Sent folder:", error);
    alert("Could not move the proposal to the Sent folder.");
  }
};

const handleMarkNotApproved = async (proposal) => {
  if (!proposal?.id) return;
  const confirmed = window.confirm("Mark this proposal as Not Approved?");
  if (!confirmed) return;
  try {
    await updateDoc(doc(db, "proposals", proposal.id), {
      status: "Not Approved",
      notApprovedAt: new Date().toISOString(),
      hasBeenSent: proposal.hasBeenSent || false,
    });
    setProposals((prev) => prev.filter((p) => p.id !== proposal.id));
  } catch (error) {
    console.error("Error marking proposal not approved:", error);
    alert("Failed to mark proposal Not Approved.");
  }
};

const handleMarkCompleted = async (proposal) => {
  if (!proposal?.id) return;
  const confirmed = window.confirm("Mark this proposal as Completed?");
  if (!confirmed) return;
  try {
    await updateDoc(doc(db, "proposals", proposal.id), {
      status: "Completed",
      completedAt: new Date().toISOString(),
    });
    setProposals((prev) => prev.filter((p) => p.id !== proposal.id));
    alert("Proposal marked as Completed.");
  } catch (error) {
    console.error("Error marking proposal completed:", error);
    alert("Could not update status.");
  }
};

const handleSendProposalEmail = async (proposal) => {
  // Emails the client (or re-sends) and keeps the proposal on this page.
  const patch = await sendPPDProposalEmail(proposal, {
    onStart: (id) => setSendingProposalId(id),
    onFinish: () => setSendingProposalId(null),
  });
  if (!patch) return;
  setProposals((prev) => prev.map((p) => (p.id === proposal.id ? { ...p, ...patch } : p)));
  setSelectedProposal((prev) => (prev?.id === proposal.id ? { ...prev, ...patch } : prev));
};

const handleToggleStatus = async (proposal, type) => {
  const proposalRef = doc(db, "proposals", proposal.id);
  let newStatus = proposal.status;
  let hasBeenSent = proposal.hasBeenSent || false;

  if (type === "sent") {
    if (proposal.status === "Not Sent") {
      newStatus = "Sent";
      hasBeenSent = true;
    } else if (proposal.status === "Sent") {
      newStatus = "Not Sent";
      hasBeenSent = false;
    } else if (proposal.status === "Approved") {
      hasBeenSent = !hasBeenSent;
    }
  } else if (type === "approval") {
    if (proposal.status === "Approved") {
      newStatus = "Sent"; // toggle back
    } else {
      newStatus = "Approved";
      hasBeenSent = true;
    }
  }

  try {
    await updateDoc(proposalRef, {
      status: newStatus,
      hasBeenSent,
    });

    setProposals((prev) =>
      prev.map((p) =>
        p.id === proposal.id ? { ...p, status: newStatus, hasBeenSent } : p
      )
    );

    // 👇 Add job when proposal just got approved
    if (proposal.status !== "Approved" && newStatus === "Approved") {
      const freshSnap = await getDocs(query(collection(db, "proposals"), where("__name__", "==", proposal.id)));
      const fresh = freshSnap.docs[0]?.data() || proposal;
      await upsertJobFromProposal({ id: proposal.id, ...fresh });
    }
    
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Failed to update proposal status.");
  }
};

const getNextWorkOrder = async (prefix) => {
  const counterRef = doc(db, "counters", `${prefix}_jobs`);
  let nextNumber;

  await runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);

    if (!snap.exists()) {
      // first time: start at 10001
      nextNumber = 10001;
      tx.set(counterRef, { lastNumber: nextNumber, updatedAt: serverTimestamp() });
    } else {
      const data = snap.data() || {};
      const last = Number(data.lastNumber);
      const safeLast = Number.isFinite(last) ? last : 10000;
      nextNumber = safeLast + 1;
      tx.update(counterRef, { lastNumber: nextNumber, updatedAt: serverTimestamp() });
    }
  });

  return `${prefix}-${nextNumber}`;
};

const handleSortBySite = () => {
  const sorted = [...proposals].sort((a, b) => {
    const nameA = a.siteName?.toLowerCase() || "";
    const nameB = b.siteName?.toLowerCase() || "";

    if (sortOrder === "asc") {
      return nameA.localeCompare(nameB);
    } else {
      return nameB.localeCompare(nameA);
    }
  });

  setProposals(sorted);
  setSortOrder(sortOrder === "asc" ? "desc" : "asc");
};

const upsertJobFromProposal = async (proposal) => {
  try {
    const jobsRef = collection(db, "jobs");
    const q = query(jobsRef, where("proposalId", "==", proposal.id));
    const existing = await getDocs(q);

    const images =
      proposal.imageURLs && proposal.imageURLs.length
        ? proposal.imageURLs
        : proposal.images || [];

    if (!existing.empty) {
      const jobDoc = existing.docs[0];
      await updateDoc(doc(db, "jobs", jobDoc.id), { status: "Active" });
      await addJobTotal({
        jobId: jobDoc.id,
        wo: jobDoc.data()?.wo || proposal.wo || jobDoc.id,
        proposalId: proposal.id,
        total: proposal.proposalTotal || proposal.price || 0,
        source: "approved-proposal",
      });
      return jobDoc.id;
    }

    // Try to get a WO, but don't fail the whole op if it errors
    let wo = "";
    try {
      wo = await getNextWorkOrder("PPD");
      await updateDoc(doc(db, "proposals", proposal.id), { wo });
      setProposals(prev => prev.map(p => p.id === proposal.id ? { ...p, wo } : p));
    } catch (e) {
      console.warn("WO generation failed; creating job without WO:", e);
    }

    const ts = new Date();
    const jobData = {
      proposalId: proposal.id,
      companyName: proposal.companyName || "",
      companyAddress: proposal.companyAddress || "",
      companyCityStateZip: proposal.companyCityStateZip || "",
      siteName: proposal.siteName || "",
      management: proposal.management || "",
      managerName: proposal.managerName || "",
      address: proposal.address || "",
      cityStateZip: proposal.cityStateZip || "",
      serviceType: proposal.serviceType || "",
      scope: proposal.scope || "",
      jobDescription: proposal.jobDescription || "",
      price: proposal.price || "",
      submittedDate: proposal.submittedDate || "",
      submittedBy: proposal.submittedBy || "",
      terms: proposal.terms || "",
      warrantyName: proposal.warrantyName || "",
      warranty: proposal.warranty || "",
      images,
      wo,
      status: "Active",
      createdAt: ts.toISOString(),
    };

    const newJobRef = await addDoc(jobsRef, jobData);
    await addJobTotal({
      jobId: newJobRef.id,
      wo,
      proposalId: proposal.id,
      total: proposal.proposalTotal || proposal.price || 0,
      source: "approved-proposal",
    });
    return newJobRef.id;
  } catch (err) {
    console.error("upsertJobFromProposal error:", err);
    alert("Failed to create/activate job. Check console for details.");
    return null;
  }
};
// 🪰 Mosquito treatment square footage tiers
const mosquitoTiers = [
  { range: "Up to 500 sq ft", min: 0, max: 500, price: 75 },
  { range: "500 - 1000 sq ft", min: 500, max: 1000, price: 95 },
  { range: "1000 - 1500 sq ft", min: 1000, max: 1500, price: 115 },
  { range: "1500 - 2000 sq ft", min: 1500, max: 2000, price: 135 },
  { range: "2000 - 2500 sq ft", min: 2000, max: 2500, price: 155 },
];


const subscriptionScopes = [
  {
    title: "Monthly Pest Control Service",
    description: `((b))MONTHLY GENERAL PEST CONTROL SERVICE
Inspect and treat interior and exterior for general household pests.
- Apply residual pesticide around structure perimeter and entry points.
- Check and refresh bait stations.
- Re-inspect for any pest activity.
- Monthly visits maintain continuous protection and customer satisfaction.
`,
    basePrice: 65, // starting residential price
    frequencyOptions: ["Monthly"],
    pricingOptions: {
      residential: { install: 65 },
      commercial: { install: 95 }
    },
    modifiers: [
      { label: "Height Fee (2+ stories)", value: 15 },
      { label: "Large Property (over ½ acre)", value: 25 }
    ]
  },
  {
    title: "Quarterly Pest Control Service",
    description: `((b))QUARTERLY PEST CONTROL SERVICE
Perform comprehensive inspection and exterior perimeter treatment every 90 days.
- Treat entry points, foundation, and landscape up to 3 ft high.
- Address ants, spiders, crickets, and other crawling insects.
- Maintain year-round protection with seasonal adjustments.
`,
    basePrice: 110,
    frequencyOptions: ["Quarterly"],
    pricingOptions: {
      residential: { install: 110 },
      commercial: { install: 150 }
    },
    modifiers: [
      { label: "Height Fee (2+ stories)", value: 25 },
      { label: "Initial Cleanout Service", value: 75 }
    ]
  },
  {
    title: "Annual Termite Inspection",
    description: `((b))ANNUAL TERMITE INSPECTION
Perform full visual inspection of accessible interior and exterior for signs of termite activity.
- Check bait stations and refresh as needed.
- Provide written report with findings and recommendations.
- Renewal required to maintain warranty coverage.
`,
    basePrice: 150,
    frequencyOptions: ["Annual"],
    pricingOptions: {
      residential: { install: 150 },
      commercial: { install: 225 }
    },
    modifiers: [
      { label: "Property Over 3,000 sq ft", value: 50 }
    ]
  },
  {
    title: "Mosquito Subscription (Seasonal)",
    description: `((b))MOSQUITO CONTROL – RECURRING SEASONAL PROGRAM
Inspect and treat property every 21–30 days from early spring through fall.
- Apply larvicide in standing water and mist blower to shaded areas.
- Monitor mosquito activity and adjust treatments as needed.
- Subscription billed monthly during mosquito season.
`,
    basePrice: 75,
    frequencyOptions: ["Monthly", "Bi-Weekly"],
    pricingOptions: {
      residential: { install: 75 },
      commercial: { install: 125 }
    },
    modifiers: [
      { label: "Large Property (over ½ acre)", value: 40 },
      { label: "Pond or Water Feature Present", value: 30 }
    ]
  }
];



const singleServiceScopes = [
  {
    title: "Rodent Exclusion (One-Way Door Installation)",
    description: `((b))RODENT EXCLUSION SERVICE – ONE-WAY DOOR INSTALLATION
Inspect structure for active entry points and install one-way door for humane removal.
- Seal gaps and openings with steel mesh and foam.
- Follow-up 7–10 days later to remove door and seal entry.
`,
    basePrice: 275,
    frequencyOptions: ["One-Time"],
    pricingOptions: {
      residential: { install: 275 },
      commercial: { install: 375 }
    },
    modifiers: [
      { label: "Attic or Roofline Access", value: 75 },
      { label: "Multiple Entry Points", valuePerUnit: 25 }
    ]
  },
  {
    title: "Termite Treatment (Liquid)",
    description: `((b))TERMITE TREATMENT – LIQUID APPLICATION
Trench and treat soil along foundation using Termidor HE or equivalent.
- Drill and treat slab as required.
- Patch holes neatly after treatment.
- Protection up to 10 years depending on conditions.
`,
    basePrice: 950,
    frequencyOptions: ["One-Time"],
    pricingOptions: {
      residential: { install: 950 },
      commercial: { install: 1250 }
    },
    modifiers: [
      { label: "Basement Foundation", value: 150 },
      { label: "Crawl Space Foundation", value: 100 }
    ]
  },
  {
    title: "Termite Bait Station Installation",
    description: `((b))TERMITE BAIT SYSTEM INSTALLATION
Install termite monitoring and bait stations around the building perimeter.
- Quarterly inspection and bait replenishment required.
- Includes layout diagram and schedule.
`,
    basePrice: 450,
    frequencyOptions: ["Quarterly"],
    pricingOptions: {
      residential: { install: 450 },
      commercial: { install: 650 }
    },
    modifiers: [
      { label: "Height Fee (2+ stories)", value: 50 },
      { label: "Additional Bait Stations", valuePerUnit: 20 }
    ]
  },
  {
    title: "General Pest Control – Interior & Exterior",
    description: `((b))GENERAL PEST CONTROL – INTERIOR AND EXTERIOR
Inspect and treat for ants, spiders, roaches, and silverfish.
- Apply residual insecticide to entry points and baseboards.
- Treat foundation perimeter and garages.
`,
    basePrice: 125,
    frequencyOptions: ["One-Time"],
    pricingOptions: {
      residential: { install: 125 },
      commercial: { install: 175 }
    },
    modifiers: [
      { label: "Height Fee (2+ stories)", value: 25 },
      { label: "Heavy Infestation", value: 50 }
    ]
  },
  {
    title: "Wasp or Hornet Nest Removal",
    description: `((b))WASP / HORNET NEST REMOVAL
Locate and remove active nests safely.
- Treat entry points and dispose of nest material.
- Seal re-entry areas.
`,
    basePrice: 145,
    frequencyOptions: ["One-Time"],
    pricingOptions: {
      residential: { install: 145 },
      commercial: { install: 185 }
    },
    modifiers: [
      { label: "Nest Above 2 Stories", value: 50 },
      { label: "Multiple Nests", valuePerUnit: 30 }
    ]
  },
  {
    title: "Bed Bug Treatment",
    description: `((b))BED BUG CONTROL – CHEMICAL TREATMENT
Inspect all sleeping areas and furniture seams.
- Apply contact insecticides and steam where needed.
- Follow-up in 14 days.
`,
    basePrice: 425,
    frequencyOptions: ["One-Time"],
    pricingOptions: {
      residential: { install: 425 },
      commercial: { install: 575 }
    },
    modifiers: [
      { label: "More than 2 Bedrooms", value: 75 },
      { label: "Apartment Complex or Hotel Unit", value: 125 }
    ]
  },
  {
    title: "Wildlife Trapping (Squirrel / Raccoon)",
    description: `((b))WILDLIFE REMOVAL – HUMANE LIVE TRAPPING
Set live traps and relocate animals per regulations.
- Seal entry points after removal.
`,
    basePrice: 325,
    frequencyOptions: ["One-Time"],
    pricingOptions: {
      residential: { install: 325 },
      commercial: { install: 475 }
    },
    modifiers: [
      { label: "Roof Access Required", value: 50 },
      { label: "Multiple Animals", valuePerUnit: 75 }
    ]
  },
  {
    title: "Flea Treatment (Interior / Exterior)",
    description: `((b))FLEA CONTROL SERVICE
Vacuum and treat carpets, pet areas, and yards.
- Pets must be treated the same day.
- Re-entry after 2–3 hours.
`,
    basePrice: 175,
    frequencyOptions: ["One-Time"],
    pricingOptions: {
      residential: { install: 175 },
      commercial: { install: 250 }
    },
    modifiers: [
      { label: "Heavy Infestation", value: 75 },
      { label: "Pets Over 3 in Home", value: 50 }
    ]
  },
  {
    title: "Carpenter Ant / Bee Treatment",
    description: `((b))CARPENTER ANT / BEE TREATMENT
Inspect and treat galleries and eaves with dust/insecticide.
- Seal nesting holes with filler.
`,
    basePrice: 195,
    frequencyOptions: ["One-Time"],
    pricingOptions: {
      residential: { install: 195 },
      commercial: { install: 275 }
    },
    modifiers: [
      { label: "Height Fee (2+ stories)", value: 35 },
      { label: "Multiple Nests or Holes", valuePerUnit: 25 }
    ]
  }
];




  return (
    <div className="proposals-container">
      <div className="center-add-button">
  <button className="blue-button" onClick={handleAddProposalClick}>
    Add Proposal
  </button>
</div>
      <h2 style={{margin:"0 0 12px 0", textAlign:"center"}}>Priority Pest Defense Approved Proposals</h2>
   
      {isEditing && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>{selectedProposal ? "Edit Proposal" : "Add Proposal"}</h3>
            <form className="form-container" onSubmit={handleSubmit}>
              <label>Logo:</label>
              <select name="logo" value={selectedLogo.name} onChange={handleLogoChange} required>
                {logoOptions.map(option => (
                  <option key={option.name} value={option.name}>{option.name}</option>
                ))}
              </select>
             <label>Company Name:</label>
<input
  type="text"
  name="companyName"
  value={newProposal.companyName}
  readOnly
/>


              <label>Company Address:</label>
              <input type="text" name="companyAddress" value={newProposal.companyAddress} onChange={handleInputChange} readOnly />
              <label>Company City, State, Zip:</label>
              <input type="text" name="companyCityStateZip" value={newProposal.companyCityStateZip} onChange={handleInputChange} readOnly />
              <label>Site Name:</label>
              <select name="siteName" value={newProposal.siteName} onChange={handleSiteNameChange} required>
                <option value="">Select Site Name</option>
                {sortedProperties.map(property => (
                  <option key={property.id} value={property.propertyName}>{property.propertyName}</option>
                ))}
              </select>
              <label>Management:</label>
              <input type="text" name="management" value={newProposal.management} onChange={handleInputChange} readOnly />
              <label>Manager Name:</label>
              <input type="text" name="managerName" value={newProposal.managerName} onChange={handleInputChange} readOnly />
              <label>Address:</label>
              <select name="address" value={newProposal.address} onChange={handleInputChange} required>
                <option value="">Select Address</option>
                {properties.map(property => (
                  <option key={property.id} value={property.address || property.managementAddress}>{property.address || property.managementAddress}</option>
                ))}
              </select>
              <label>City, State, Zip:</label>
              <select name="cityStateZip" value={newProposal.cityStateZip} onChange={handleInputChange} required>
                <option value="">Select City, State, Zip</option>
                {properties.map(property => (
                  <option key={property.id} value={`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}>{`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}</option>
                ))}
              </select>
              <label>Scope:</label>
              <input type="text" name="scope" value={newProposal.scope} onChange={handleInputChange} required />
             {/* Pest Control Scopes */}
{/* ===== SCOPES SECTION ===== */}
<div className="scope-section">
  <h4>Select Scope:</h4>

  {/* Parent Buttons */}
  <div className="scope-toggle-buttons">
    <button
      type="button"
      className="scope-toggle"
      onClick={() =>
        setShowSubscriptions(prev => !prev)
      }
    >
      {showSubscriptions ? "Hide Subscription Services" : "Show Subscription Services"}
    </button>

    <button
      type="button"
      className="scope-toggle"
      onClick={() =>
        setShowSingle(prev => !prev)
      }
    >
      {showSingle ? "Hide One-Time Services" : "Show One-Time Services"}
    </button>
  </div>

  {/* Subscription Scopes */}
  {showSubscriptions && (
    <div className="scope-buttons-container">
      {subscriptionScopes.map((scope, i) => (
        <button
        key={i}
        type="button"
        className={`scope-button ${newProposal.selectedScopes?.includes(scope.title) ? "active" : ""}`}
        disabled={newProposal.selectedScopes?.includes(scope.title)}
        onClick={() => openPricingModal(scope)}
      >
        {scope.title}
      </button>
      
      ))}
    </div>
  )}

  {/* One-Time Scopes */}
  {showSingle && (
    <div className="scope-buttons-container">
      {singleServiceScopes.map((scope, i) => (
        <button
          key={i}
          type="button"
          className={`scope-button ${newProposal.selectedScopes?.includes(scope.title) ? "active" : ""}`}
          disabled={newProposal.selectedScopes?.includes(scope.title)}
          onClick={() =>
            setNewProposal(prev => {
              const separator = prev.jobDescription.trim() ? "\n\n" : "";
              const updatedDesc = prev.jobDescription + separator + scope.description.trim();
              const updatedSelected = [...(prev.selectedScopes || []), scope.title];
              return { ...prev, jobDescription: updatedDesc, selectedScopes: updatedSelected };
            })
          }
        >
          {scope.title}
        </button>
      ))}
    </div>
  )}

  {/* Clear All */}
  <button
    type="button"
    className="clear-scope-button"
    onClick={() =>
      setNewProposal(prev => ({
        ...prev,
        jobDescription: "",
        selectedScopes: []
      }))
    }
  >
    🗑 Clear All
  </button>
</div>





              <label>Job Description: (Notes: Add ((b)) for bold lines, add ((i)) for italic lines. Bold and italic lines, and spaces have no bullets.) </label>
              <textarea name="jobDescription" value={newProposal.jobDescription} onChange={handleInputChange}></textarea>
              <label>Job Description Preview:</label>
              <div className="job-description-preview">
                {parseJobDescription(newProposal.jobDescription)}
              </div>
              <label>Price:</label>
              <textarea
                name="price"
                value={newProposal.price}
                onChange={handleInputChange}
                rows={3}
                required
              ></textarea>

              <label>Proposal Total (Internal Only - does not show on proposal):</label>
              <input
                type="number"
                name="proposalTotal"
                value={newProposal.proposalTotal || ""}
                onChange={handleInputChange}
                placeholder="Internal proposal total"
              />
              {priceBreakdown.length > 0 && (
  <div className="price-breakdown-container">
    <h4>Added Services:</h4>
    <ul>
    {priceBreakdown.map((line, i) => (
  <li key={i}>
    {line.description} — <strong>${(line.price ?? 0).toFixed(2)}</strong>

          <button
            type="button"
            className="edit-line"
            onClick={() => {
              const newPrice = parseFloat(prompt("Enter new price:", line.price));
              if (!isNaN(newPrice)) {
                const updated = [...priceBreakdown];
                updated[i].price = newPrice;
                setPriceBreakdown(updated);
                const newTotal = updated.reduce((sum, item) => sum + item.price, 0);
                setNewProposal(prev => ({ ...prev, price: newTotal.toFixed(2) }));
              }
            }}
          >✏️</button>
          <button
            type="button"
            className="delete-line"
            onClick={() => {
              const updated = priceBreakdown.filter((_, index) => index !== i);
              setPriceBreakdown(updated);
              const newTotal = updated.reduce((sum, item) => sum + item.price, 0);
              setNewProposal(prev => ({ ...prev, price: newTotal.toFixed(2) }));
            }}
          >🗑️</button>
        </li>
      ))}
    </ul>
    {(() => {
  const freqLabel =
    priceBreakdown.some(p => /month/i.test(p.description))
      ? "Total Billed Monthly:"
      : priceBreakdown.some(p => /quarter/i.test(p.description))
      ? "Total Billed Quarterly:"
      : priceBreakdown.some(p => /annual|year/i.test(p.description))
      ? "Total Billed Yearly:"
      : "Total Due Now:";
  return <p><strong>{freqLabel} ${newProposal.price}</strong></p>;
})()}

  </div>
)}


              <label>Submitted Date:</label>
              <input type="date" name="submittedDate" value={newProposal.submittedDate} onChange={handleInputChange} />
              <label>Submitted By:</label>
              <select
  name="submittedBy"
  value={newProposal.submittedBy}
  onChange={handleInputChange}
>
  <option value="">Select User</option>
  {users.map(user => {
    const initials = `${(user.firstName || "").charAt(0)} ${(user.lastName || "").charAt(0)}`.trim();
    return (
      <option key={user.id} value={initials}>
        {initials}
      </option>
    );
  })}
</select>

              <label>Image Display:</label>
              <input type="file" name="imageDisplay" onChange={handleFileChange} multiple />
              <label>Terms:</label>
              <select name="terms" value={newProposal.terms} onChange={handleInputChange} required>
                <option value="">Select Terms</option>
                {termsOptions.map(term => (
                  <option key={term.name} value={term.content}>{term.name}</option>
                ))}
              </select>
              <label>Warranty:</label>
              <select
                name="warrantyName"
                value={newProposal.warrantyName}
                onChange={handleWarrantyChange}
                required
              >
                <option value="">Select Warranty</option>
                {warrantyOptions.map(opt => (
                  <option key={opt.name} value={opt.name}>{opt.name}</option>
                ))}
              </select>
              <div className="modal-buttons">
                <button type="submit" className="blue-button">Save</button>
                <button type="button" className="red-button" onClick={() => setIsEditing(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

{showPriceModal && selectedScope && (
  <div className="modal-overlay">
    <div className="modal">
      <h3>{selectedScope.title}</h3>
      <p><strong>Customize your service before adding:</strong></p>

      <label>Property Type:</label>
      <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
        <option value="residential">Residential</option>
        <option value="commercial">Commercial</option>
      </select>

      {selectedScope.frequencyOptions && (
        <>
          <label>Service Frequency:</label>
          <select value={selectedFrequency} onChange={(e) => setSelectedFrequency(e.target.value)}>
            {selectedScope.frequencyOptions.map((f) => (
              <option key={f} value={f}>{f}</option>
            ))}
          </select>
        </>
      )}
      {/* 🪰 Mosquito square-foot dropdown */}
{selectedScope.title.includes("Mosquito") && (
  <>
    <label>Property Size:</label>
    <select
      value={selectedSqFtRange}
      onChange={(e) => setSelectedSqFtRange(e.target.value)}
    >
      {mosquitoTiers.map((tier) => (
        <option key={tier.range} value={tier.range}>
          {tier.range} — ${tier.price} per treatment
        </option>
      ))}
    </select>
  </>
)}


      <label>Quantity (if applicable):</label>
      <input
        type="number"
        min="1"
        value={quantity}
        onChange={(e) => setQuantity(Number(e.target.value))}
      />

      {selectedScope.modifiers?.some((m) => m.label.includes("Height")) && (
        <label style={{ display: "block", marginTop: "10px" }}>
          <input
            type="checkbox"
            checked={includeHeightFee}
            onChange={(e) => setIncludeHeightFee(e.target.checked)}
          />{" "}
          Add Height Fee (+${selectedScope.modifiers.find((m) => m.label.includes("Height")).value})
        </label>
      )}

      <p><strong>Calculated Price:</strong> ${calculatedPrice.toFixed(2)}</p>

      <div className="modal-buttons">
        <button
          className="blue-button"
          onClick={() => {
            const separator = newProposal.jobDescription.trim() ? "\n\n" : "";
            const updatedDesc = newProposal.jobDescription + separator + selectedScope.description.trim();
            // Create an object for the breakdown
const lineItem = {
  description: `${selectedScope.title} (${selectedType}, ${selectedFrequency}, qty ${quantity})`,
  price: calculatedPrice
};

// Update the proposal and breakdown arrays
setNewProposal((prev) => ({
  ...prev,
  jobDescription: updatedDesc,
  price: (Number(prev.price || 0) + calculatedPrice).toFixed(2),
}));

setPriceBreakdown((prev) => [...prev, lineItem]);
closePriceModal();

          }}
        >
          Add to Proposal
        </button>
        <button className="red-button" onClick={closePriceModal}>Cancel</button>
      </div>
    </div>
  </div>
)}


<div className="table-container">
  <div className="table-scroll">
    <table>
          <thead>
            <tr>
            <th style={{ whiteSpace: "nowrap" }}>
  Site Name
  <button 
    onClick={handleSortBySite}
    style={{
      marginLeft: "6px",
      padding: "2px 6px",
      fontSize: "11px",
      cursor: "pointer"
    }}
  >
    {sortOrder === "asc" ? "▲" : "▼"}
  </button>
</th>

              <th>Scope</th>
              <th>Submitted Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
          {proposals.map(proposal => (
  <tr
  key={proposal.id}
  style={{
    backgroundColor:
      proposal.status === "Approved"
        ? "#d4edda" // green
        : proposal.status === "Sent"
        ? "#f8d7da" // pink
        : "transparent"
  }}
>
  <td>{proposal.siteName}</td>
  <td>{proposal.scope}</td>
  <td>{formatDateMMDDYYYY(proposal.submittedDate)}</td>
  <td>{formatInitials(proposal.submittedBy)}</td>
  <td>
  <button className="smalldetails-button" onClick={() => setSelectedProposal(proposal)}>Details</button>
  <button className="smalldelete-button" onClick={() => handleDeleteProposalDirect(proposal.id)} style={{ marginLeft: "8px" }}>Delete</button>
  <button
    className={`smallstatus-button ${proposal.status === "Approved" ? "approved" : ""}`}
    onClick={() => handleToggleStatus(proposal, "approval")}
    style={{ marginLeft: "8px" }}
  >
    Approved
  </button>
  <button
    className="smallstatus-button not-approved"
    onClick={() => handleMarkNotApproved(proposal)}
    style={{ marginLeft: "8px" }}
  >
    Not Approved
  </button>
  <button
    className={`smallstatus-button ${proposal.hasBeenSent ? "sent" : ""}`}
    onClick={() => handleSendProposalEmail(proposal)}
    disabled={sendingProposalId === proposal.id}
    title={describeLastProposalEmail(proposal) || "Email this proposal to the client"}
    style={{ marginLeft: "8px" }}
  >
    {sendingProposalId === proposal.id ? "Sending..." : proposal.hasBeenSent ? "Resend Email" : "Click to Send"}
  </button>
  <button
    className="smallstatus-button"
    onClick={() => handleAddToSentFolder(proposal)}
    style={{ marginLeft: "8px" }}
  >
    Add to Sent Folder
  </button>
  <button
    className="smallcomplete-button"
    onClick={() => handleMarkCompleted(proposal)}
    style={{ marginLeft: "8px" }}
  >
    Completed
  </button>
</td>

</tr>

))}


</tbody>
</table>
</div>
</div>

      {selectedProposal && (
        <div className="modal full-size-modal"> {/* Add full-size-modal class */}
          {isEditing ? (
            <div className="form-container shrink-form"> {/* Add shrink-form class */}
             <label>Company Name:</label>
<input
  type="text"
  name="companyName"
  value={newProposal.companyName}
  readOnly
/>


              <label>Company Address:</label>
              <input type="text" name="companyAddress" value={newProposal.companyAddress} onChange={handleInputChange} readOnly />
              <label>Company City, State, Zip:</label>
              <input type="text" name="companyCityStateZip" value={newProposal.companyCityStateZip} onChange={handleInputChange} readOnly />
              <label>Site Name:</label>
              <select name="siteName" value={newProposal.siteName} onChange={handleSiteNameChange} required>
                <option value="">Select Site Name</option>
                {sortedProperties.map(property => (
                  <option key={property.id} value={property.propertyName}>{property.propertyName}</option>
                ))}
              </select>
              <label>Management:</label>
              <input type="text" name="management" value={newProposal.management} onChange={handleInputChange} readOnly />
              <label>Manager Name:</label>
              <input type="text" name="managerName" value={newProposal.managerName} onChange={handleInputChange} readOnly />
              <label>Address:</label>
              <select name="address" value={newProposal.address} onChange={handleInputChange} required>
                <option value="">Select Address</option>
                {properties.map(property => (
                  <option key={property.id} value={property.address || property.managementAddress}>{property.address || property.managementAddress}</option>
                ))}
              </select>
              <label>City, State, Zip:</label>
              <select name="cityStateZip" value={newProposal.cityStateZip} onChange={handleInputChange} required>
                <option value="">Select City, State, Zip</option>
                {properties.map(property => (
                  <option key={property.id} value={`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}>{`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}</option>
                ))}
              </select>
              <label>Scope:</label>
              <input type="text" name="scope" value={newProposal.scope} onChange={handleInputChange} required />
              <label>Job Description:</label>
<textarea
  name="jobDescription"
  value={newProposal.jobDescription}
  onChange={handleInputChange}
  rows={6}
/>

<label>Job Description Preview:</label>
<div className="job-description-preview">
  {newProposal.jobDescription.split("\n").map((line, index) => {
    if (line.trim() === "") {
      return <br key={index} />; // Preserve blank lines
    } else if (line.startsWith("((b))")) {
      return <span key={index} className="job-bold"><strong>{line.replace("((b))", "").trim()}</strong><br /></span>;
    } else if (line.startsWith("((i))")) {
      return <span key={index} className="job-italic"><i>{line.replace("((i))", "").trim()}</i><br /></span>;
    } else {
      return <span key={index} className="job-bullet">• {line} <br /></span>;
    }
  })}
</div>

              <label>Price:</label>
              <textarea
                name="price"
                value={newProposal.price}
                onChange={handleInputChange}
                rows={3}
                required
              ></textarea>

              <label>Proposal Total (Internal Only - does not show on proposal):</label>
              <input
                type="number"
                name="proposalTotal"
                value={newProposal.proposalTotal || ""}
                onChange={handleInputChange}
                placeholder="Internal proposal total"
              />
              <label>Submitted Date:</label>
              <input type="date" name="submittedDate" value={newProposal.submittedDate} onChange={handleInputChange} />
              <label>Submitted By:</label>
              <select
  name="submittedBy"
  value={newProposal.submittedBy}
  onChange={handleInputChange}
>
  <option value="">Select User</option>
  {users.map(user => {
    const initials = `${(user.firstName || "").charAt(0)} ${(user.lastName || "").charAt(0)}`.trim();
    return (
      <option key={user.id} value={initials}>
        {initials}
      </option>
    );
  })}
</select>

              <label>Image Display:</label>
              <input type="file" name="imageDisplay" onChange={handleFileChange} multiple />
              <label>Terms:</label>
              <select name="terms" value={newProposal.terms} onChange={handleInputChange} required>
                <option value="">Select Terms</option>
                {termsOptions.map(term => (
                  <option key={term.name} value={term.content}>{term.name}</option>
                ))}
              </select>
              <label>Warranty:</label>
              <select
                name="warrantyName"
                value={newProposal.warrantyName}
                onChange={handleWarrantyChange}
                required
              >
                <option value="">Select Warranty</option>
                {warrantyOptions.map(opt => (
                  <option key={opt.name} value={opt.name}>{opt.name}</option>
                ))}
              </select>
              <div className="modal-buttons">
                <button onClick={handleEditProposal} className="blue-button">Save</button>
                <button onClick={handleCancel} className="red-button">Cancel</button>
              </div>
            </div>
          ) : (
            <div id="printableArea" className="printable-content full-size-content"> {/* Add full-size-content class */}
              <div className="page-border">
                <div className="proposals-container">
                  {/* .companylogo-container */}
                  <div className="companylogo-container">
                    <img src={selectedLogo.url} alt="Company Logo" className={`resizable-logo ${selectedLogo.alignment}`} />
                  </div>

                  {/* .companyinfo-container and .property-container */}
                  <div className="row-container">
                    <div className="companyinfo-container bordered-box common-shadow">
                      <p><strong>{selectedProposal.companyName}</strong></p>
                      <p><strong>{selectedProposal.companyAddress}</strong></p>
                      <p><strong>{selectedProposal.companyCityStateZip}</strong></p>
                    </div>
                    <div className="property-container bordered-box">
                      <p><strong>{selectedProposal.siteName}</strong></p>
                      <p><strong>{selectedProposal.management}</strong></p>
                      <p><strong>{selectedProposal.address}</strong></p>
                      <p><strong>{selectedProposal.cityStateZip}</strong></p>
                    </div>
                  </div>

                  {/* .scope-container */}
                  <div className="scope-container bordered-box">
                    <p><strong>Scope:</strong> {selectedProposal.scope}</p>
                  </div>

                  {/* .description-container */}
                  <div className="description-container bordered-box">
                    <p><strong>Job Description:</strong></p>
                    <p className="job-description">
                      {selectedProposal.jobDescription.split("\n").map((line, index) => {
                        if (line.trim() === "") {
                          return <br key={index} />;
                        } else if (line.startsWith("((b))")) {
                          return <span key={index} className="job-bold"><strong>{line.replace("((b))", "").trim()}</strong><br /></span>;
                        } else if (line.startsWith("((i))")) {
                          return <span key={index} className="job-italic"><i>{line.replace("((i))", "").trim()}</i><br /></span>;
                        } else {
                          return <span key={index} className="job-bullet">• {line} <br /></span>;
                        }
                      })}
                    </p>
                  </div>

                  {/* .total-container */}
                  <div className="total-container bordered-box common-shadow">
  <p className="total-text"><strong>{selectedProposal.price}</strong></p>
</div>

                  {/* .noteacceptance-container */}
                  <div className="noteacceptance-container centered-text">
                    <p><strong>NOTE: Please note that any change orders to the work proposed due to items discovered during demolition will be communicated to the owner and agreed upon before work commences.</strong></p>
                  </div>

                   {/* .acceptance-container */}
                   <div className="acceptance-container centered-text">
                    <p><strong>Submitted by:</strong> {formatInitials(selectedProposal.submittedBy)} {formatDateMMDDYYYY(selectedProposal.submittedDate)}</p>
                    <p><strong></strong><i> This proposal may be withdrawn if not accepted within 30 days.</i></p>
                    <p><i>Acceptance of Proposal: The above prices, specifications, and conditions are satisfactory and are hereby accepted. You are authorized to do the work as specified. Payment will be made as outlined below. In the event payment shall not be made as specified, I agree to pay all reasonable costs and expenses of collection, including but not limited to attorney’s fees, whether or not suit is actually filed. A monthly service charge in the amount of 1.5% ($5.00 minimum) will be applied to amounts 30 days overdue or greater.</i></p>
                    <div className="signature-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "20px" }}>
                      <p><strong>Signature: ______________________________</strong></p>
                      <p><strong>Date: ____________________</strong></p>
                    </div>
                  </div>

                  {/* .image-container */}
                  {/* Only render image container if there are image URLs */}
{getProposalImageUrls(selectedProposal).length > 0 && (
  <div className="image-container bordered-box">
    <div className="image-grid">
      {getProposalImageUrls(selectedProposal).map((imageUrl, index) => (
        <div key={index} className="image-wrapper">
          <img
            src={imageUrl}
            alt={`Uploaded ${index + 1}`}
            className="proposal-image"
            crossOrigin="anonymous"
          />
        </div>
      ))}
    </div>
  </div>
)}


                  {/* Add a page break before .terms-container */}

                  {/* .terms-container */}
                  <div className="terms-container bordered-box">
                    <p><strong>Terms and Conditions:</strong> {selectedProposal.terms}</p>
                  </div>

                  {/* .warranty-container */}
                  {selectedProposal.warrantyName !== "No Warranty" && selectedProposal.warranty && (
  <>
    <div className="warranty-container bordered-box">
      <p><strong>Warranty:</strong> {selectedProposal.warrantyName}</p>
    </div>
    <div className="warranty-container bordered-box">
      {selectedProposal.warranty.split("\n").map((line, i) => (
        <p key={i}>{line}</p>
      ))}
    </div>
  </>
)}

                </div>
              </div>



              <div className="no-print">
  {describeLastProposalEmail(selectedProposal) && (
    <div style={{ marginBottom: "10px", fontWeight: 600, color: "#1e3a8a" }}>
      {describeLastProposalEmail(selectedProposal)}
    </div>
  )}
  <div className="modal-buttons">
    <button onClick={handlePrint} className="blue-button">Print/Download</button>
    <button
      onClick={() => handleSendProposalEmail(selectedProposal)}
      className={`smallstatus-button ${selectedProposal.hasBeenSent ? "sent" : ""}`}
      disabled={sendingProposalId === selectedProposal.id}
      title="Emails the saved PDF to the property manager/client from Priority Pest Defense"
    >
      {sendingProposalId === selectedProposal.id ? "Sending..." : selectedProposal.hasBeenSent ? "Resend Email" : "Email to Client"}
    </button>
    <button onClick={() => setIsEditing(true)} className="blue-button">Edit</button>
    <button onClick={handleCloseDetails} className="green-button">Close</button>
    {pdfDownloadUrl && (
      <div style={{ marginTop: "10px" }}>
        <a
          href={pdfDownloadUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="blue-button"
        >
          Download PDF
        </a>
      </div>
    )}
  </div>
  <a id="pdfLink" href="#" target="_blank"></a>
  <iframe id="pdfViewer" width="100%" height="600px"></iframe>
</div>
</div>
          )}
        </div>
      )}

      {showDeleteConfirm && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Are you sure you want to delete?</h3>
            <div className="modal-buttons">
              <button onClick={handleDeleteProposal} className="red-button">Yes</button>
              <button onClick={() => setShowDeleteConfirm(false)} className="green-button">No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PPDApprovedProposals;